import { ResetPasswordPayload, ResetPasswordResponse } from "@/app/auth/reset-password/reset-password.entity.ts";
import { AuthRepository } from "@/repositories/auth.repository.ts";

export async function resetPassword(payload: ResetPasswordPayload): Promise<ResetPasswordResponse> {
  if (payload.password !== payload.confirmPassword) {
    throw new Error("Passwords do not match");
  }

  await AuthRepository.updatePassword(payload.password);
  
  return {
    success: true,
    message: "Password reset successfully. You can now login with your new password.",
  };
}

